<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="true"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<div class="content-page">
    <div class="content p-1 crumbs">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">Sales Tax Panel</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    
    @if (security.permitted('reports', 'sales tax', 'view')) {
        <aside>            
            <form [formGroup]="form">
                <div class="form-group">
                    <select class="form-control form-control-sm" name="lot" id="lot-filter" formControlName="lotId">
                        <option value="0">All Lots</option>
                        @for (lot of lots; track lot.id) {
                            <option value="{{lot.id}}">{{lot.contact.name}}</option>
                        }
                    </select>
                </div>
                <div class="form-group">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="input-group-text">from</span>
                        </div>
                        <input type="date" select class="form-control form-control-sm" name="from" id="from-filter" formControlName="from" />
                    </div>
                </div>
                <div class="form-group">
                    
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="input-group-text">to</span>
                        </div>
                        <input type="date" select class="form-control form-control-sm" name="to" id="to-filter" formControlName="to" />
                    </div>
                </div>
            </form>
        </aside>

        <main>

            <h1 class="text-center">Sales Tax QC Report</h1>
            
            @if (grouped) {
                <div class="detail">
                    <div class="entity">
                        <h4>{{grouped.name}}</h4>
                        <p>{{grouped.address || 'No address set'}}</p>
                        <p>{{grouped.cityStateZip || ''}}</p>
                    </div>

                    <div class="gov">
                        <div class="gov-item">
                            <p>GD Number:</p>
                            <p>{{grouped.dealerNumber}}</p>
                        </div>
                        <div class="gov-item">
                            <p>Taxpayer Number:</p>
                            <p>{{grouped.einNumber}}</p>
                        </div>
                    </div>
                </div>

                <hr class="no-break" />

                <h4>Sales Tax Report Between {{form.get('from').value | date:'shortDate'}} and {{form.get('to').value | date:'shortDate'}}</h4>

                <table id="receipt-summary" class="table table-sm table-bordered">
                    <caption class="text-muted"><sup>*</sup> For the purposes of the Sales Tax QC report and the associated Sales Tax Report the Taxable Amount is simply defined to be the Tax Due divided by the Sales Tax Rate.</caption>
                    <thead>
                        <tr>
                            <th scope="col">Receipts</th>
                            <th scope="col">Total Received</th>
                            <th scope="col">Taxable Amount<sup>*</sup></th>
                            <th scope="col">Tax Due</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Deposits - Tax Deferred In-House Finance</td>
                            <td>{{grouped.deposits.deferred.collected | currency}}</td>
                            <td>{{grouped.deposits.deferred.taxable | currency}}</td>
                            <td>{{grouped.deposits.deferred.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Deposits - Tax Paid In-House Finance</td>
                            <td>{{grouped.deposits.paid.collected | currency}}</td>
                            <td>{{grouped.deposits.paid.taxable | currency}}</td>
                            <td>{{grouped.deposits.paid.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Deposits - Outside Finance</td>
                            <td>{{grouped.deposits.outside.collected | currency}}</td>
                            <td>{{grouped.deposits.outside.taxable | currency}}</td>
                            <td>{{grouped.deposits.outside.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Iniitial Down - Tax Deferred In-House Finance</td>
                            <td>{{grouped.initial.deferred.collected | currency}}</td>
                            <td>{{grouped.initial.deferred.taxable | currency}}</td>
                            <td>{{grouped.initial.deferred.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Iniitial Down - Tax Paid In-House Finance</td>
                            <td>{{grouped.initial.paid.collected | currency}}</td>
                            <td>{{grouped.initial.paid.taxable | currency}}</td>
                            <td>{{grouped.initial.paid.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Iniitial Down - Outisde Finance</td>
                            <td>{{grouped.initial.outside.collected | currency}}</td>
                            <td>{{grouped.initial.outside.taxable | currency}}</td>
                            <td>{{grouped.initial.outside.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Total In-House Finance Collections</td>
                            <td>{{grouped.bhph.collected | currency}}</td>
                            <td>{{grouped.bhph.taxable | currency}}</td>
                            <td>{{grouped.bhph.tax | currency}}</td>
                        </tr>
                        <tr class="inset">
                            <td>Tax Deferred In-House Finance Collections</td>
                            <td>{{grouped.bhph.deferred.collected | currency}}</td>
                            <td>{{grouped.bhph.deferred.taxable | currency}}</td>
                            <td>{{grouped.bhph.deferred.tax | currency}}</td>
                        </tr>
                        <tr class="inset">
                            <td>Tax Paid In-House Finance Collections</td>
                            <td>{{grouped.bhph.paid.collected | currency}}</td>
                            <td>{{grouped.bhph.paid.taxable | currency}}</td>
                            <td>{{grouped.bhph.paid.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Outside Finance Funding</td>
                            <td>{{grouped.outside.collected | currency}}</td>
                            <td>{{grouped.outside.taxable | currency}}</td>
                            <td>{{grouped.outside.tax | currency}}</td>
                        </tr>
                        <tr class="total">
                            <td>Gross Financed Receipts</td>
                            <td>{{grouped.financed.collected | currency}}</td>
                            <td>{{grouped.financed.taxable | currency}}</td>
                            <td>{{grouped.financed.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Cash Sale Receipts</td>
                            <td>{{grouped.cash.collected | currency}}</td>
                            <td>{{grouped.cash.taxable | currency}}</td>
                            <td>{{grouped.cash.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>Wholesale Receipts</td>
                            <td>{{grouped.wholesale.collected | currency}}</td>
                            <td>{{grouped.wholesale.taxable | currency}}</td>
                            <td>{{grouped.wholesale.tax | currency}}</td>
                        </tr>
                        <tr>
                            <td>After-Sale Charge Receipts</td>
                            <td>{{grouped.after.collected | currency}}</td>
                            <td>{{grouped.after.taxable | currency}}</td>
                            <td>{{grouped.after.tax | currency}}</td>
                        </tr>
                        <tr class="total">
                            <td>Gross Receipts</td>
                            <td>{{grouped.total.collected | currency}}</td>
                            <td>{{grouped.total.taxable | currency}}</td>
                            <td>{{grouped.total.tax | currency}}</td>
                        </tr>
                    </tbody>
                </table>

                <dl>
                    <dt>Sales Tax Collection Method</dt>
                    <dd>
                        Straight Line Allocation. Treat Down Payments as 
                        Fully Taxable Principal.
                    </dd>
                </dl>

                @if (grouped && grouped.initial && grouped.initial.deferred && grouped.initial.deferred.entries && (grouped.initial.deferred.entries.length > 0)) {
                    <hr />

                    <h4>In-House Financing (Tax Deferred) Initial Down Payments</h4>

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Stock</th>
                                <th>Customer</th>
                                <th class="text-right">Initial Down Payment (Incl. Tax)</th>
                                <th class="text-right">Non-Taxable Itemized Fees</th>
                                <th class="text-right">Taxable Initial Down Payment Principal</th>
                                <th class="text-right">Tax Rate</th>
                                <th class="text-right">Tax Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of grouped.initial.deferred.entries; track entry.id;) {
                                @if (entry.tax && (entry.tax > 0)) {
                                    <tr>
                                        <td>{{entry.received | date:'shortDate'}}</td>
                                        <td>{{entry.stock}}</td>
                                        <td>{{entry.buyer}}</td>
                                        <td class="text-right">{{entry.initial + entry.initialOutside | currency}}</td>
                                        <td class="text-right">{{entry.itemized | currency}}</td>
                                        <td class="text-right">{{((entry.initialTax + entry.initialOutsideTax) / entry.taxRate) | currency}}</td>
                                        <td class="text-right">{{entry.taxRate | percent:'1.2-2'}}</td>
                                        <td class="text-right">{{entry.initialTax + entry.initialOutsideTax | currency}}</td>
                                    </tr>
                                }
                            }
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.initial.collected | currency}}</td>
                                <td class="text-right">{{grouped.initial.itemized | currency}}</td>
                                <td class="text-right">{{grouped.initial.taxable | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="6">Sales tax due on in-house financing (tax deferred) down payments:</td>
                                <td></td>
                                <td class="text-right">{{grouped.initial.tax | currency}}</td>
                            </tr>
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.initial.collected | currency}}</td>
                                <td class="text-right">{{grouped.initial.itemized | currency}}</td>
                                <td class="text-right">{{grouped.initial.taxable | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="6">Sales tax due on initial down payments:</td>
                                <td></td>
                                <td class="text-right">{{grouped.initial.tax | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (grouped && grouped.bhph && grouped.bhph.deferred && grouped.bhph.deferred.entries && (grouped.bhph.deferred.entries.length > 0)) {
                    <hr />

                    <h4>In-House Financing (Tax Deferred) Payments Collected</h4>

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Stock</th>
                                <th>Customer</th>
                                <th class="text-right">Amount Paid</th>
                                <th class="text-right">Taxable Amount</th>
                                <th class="text-right">Tax Rate</th>
                                <th class="text-right">Tax Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of grouped.bhph.deferred.entries; track entry.id;) {
                                @if (entry.tax && (entry.tax > 0)) {
                                    <tr>
                                        <td>{{entry.received | date:'shortDate'}}</td>
                                        <td>{{entry.stock}}</td>
                                        <td>{{entry.buyer}}</td>
                                        <td class="text-right">{{entry.bhphDeferred | currency}}</td>
                                        <td class="text-right">{{(entry.bhphTax / entry.taxRate) | currency}}</td>
                                        <td class="text-right">{{entry.taxRate | percent:'1.2-2'}}</td>
                                        <td class="text-right">{{entry.bhphTax | currency}}</td>
                                    </tr>
                                }
                            }
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.bhph.deferred.collected | currency}}</td>
                                <td class="text-right">{{grouped.bhph.deferred.taxable | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="5">Sales tax due on in-house financing (tax deferred) collections:</td>
                                <td></td>
                                <td class="text-right">{{grouped.bhph.deferred.tax | currency}}</td>
                            </tr>
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.bhph.deferred.collected | currency}}</td>
                                <td class="text-right">{{grouped.bhph.deferred.taxable | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="5">Sales tax due on All In-House Finance Collections:</td>
                                <td></td>
                                <td class="text-right">{{grouped.bhph.deferred.tax | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (grouped && grouped.bhph && grouped.bhph.paid && grouped.bhph.paid.entries && (grouped.bhph.paid.entries.length > 0)) {
                    <hr />

                    <h4>In-House Financing (Tax Paid) Payments Collected</h4>

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Stock</th>
                                <th>Customer</th>
                                <th class="text-right">Amount Paid</th>
                                <th class="text-right">Taxable Amount</th>
                                <th class="text-right">Tax Rate</th>
                                <th class="text-right">Tax Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of grouped.bhph.paid.entries; track entry.id;) {
                                @if (entry.tax && (entry.tax > 0)) {
                                    <tr>
                                        <td>{{entry.received | date:'shortDate'}}</td>
                                        <td>{{entry.stock}}</td>
                                        <td>{{entry.buyer}}</td>
                                        <td class="text-right">{{entry.bhphPaid | currency}}</td>
                                        <td class="text-right">{{0 | currency}}</td>
                                        <td class="text-right">{{entry.taxRate | percent:'1.2-2'}}</td>
                                        <td class="text-right">{{0 | currency}}</td>
                                    </tr>
                                }
                            }
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.bhph.paid.collected | currency}}</td>
                                <td class="text-right">{{grouped.bhph.paid.taxable | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="5">Sales tax due on in-house financing (tax deferred) collections:</td>
                                <td></td>
                                <td class="text-right">{{grouped.bhph.paid.tax | currency}}</td>
                            </tr>
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.bhph.paid.collected | currency}}</td>
                                <td class="text-right">{{grouped.bhph.paid.taxable | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="5">Sales tax due on All In-House Finance Collections:</td>
                                <td></td>
                                <td class="text-right">{{grouped.bhph.paid.tax | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (grouped && grouped.outside && grouped.outside.entries && (grouped.outside.entries.length > 0)) {
                    <hr />

                    <h4>Outside Finance Funding Transactions</h4>

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Stock</th>
                                <th>Customer</th>
                                <th class="text-right">Amount Paid</th>
                                <th class="text-right">Taxable Amount</th>
                                <th class="text-right">Tax Rate</th>
                                <th class="text-right">Tax Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of grouped.outside.entries; track entry.id;) {
                                <tr>
                                    <td>{{entry.received | date:'shortDate'}}</td>
                                    <td>{{entry.stock}}</td>
                                    <td>{{entry.buyer}}</td>
                                    <td class="text-right">{{entry.outside | currency}}</td>
                                    <td class="text-right">{{0 | currency}}</td>
                                    <td class="text-right">{{entry.taxRate | percent:'1.2-2'}}</td>
                                    <td class="text-right">{{entry.tax | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.outside.collected | currency}}</td>
                                <td class="text-right">{{grouped.outside.taxable | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="5">Sales tax due on outside finance transactions:</td>
                                <td></td>
                                <td class="text-right">{{grouped.outside.tax | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (grouped && grouped.cash && grouped.cash.entries && (grouped.cash.entries.length > 0)) {
                    <hr />

                    <h4>Cash Sale Transactions</h4>

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Stock</th>
                                <th>Customer</th>
                                <th class="text-right">Amount Paid</th>
                                <th class="text-right">Sales Price</th>
                                <th class="text-right">Tax Rate</th>
                                <th class="text-right">Tax Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of grouped.cash.entries; track entry.id;) {
                                <tr>
                                    <td>{{entry.received | date:'shortDate'}}</td>
                                    <td>{{entry.stock}}</td>
                                    <td>{{entry.buyer}}</td>
                                    <td class="text-right">{{entry.cash | currency}}</td>
                                    <td class="text-right">{{entry.price | currency}}</td>
                                    <td class="text-right">{{entry.taxRate | percent:'1.2-2'}}</td>
                                    <td class="text-right">{{entry.tax | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.cash.collected | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="5">Sales tax due on cash sale transactions:</td>
                                <td></td>
                                <td class="text-right">{{grouped.cash.tax | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (grouped && grouped.wholesale && grouped.wholesale.entries && (grouped.wholesale.entries.length > 0)) {
                    <hr />

                    <h4>Wholesale Transactions</h4>

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Stock</th>
                                <th>Customer</th>
                                <th class="text-right">Amount Paid</th>
                                <th class="text-right">Sales Price</th>
                                <th class="text-right">Tax Rate</th>
                                <th class="text-right">Tax Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of grouped.wholesale.entries; track entry.id;) {
                                <tr>
                                    <td>{{entry.received | date:'shortDate'}}</td>
                                    <td>{{entry.stock}}</td>
                                    <td>{{entry.buyer}}</td>
                                    <td class="text-right">{{entry.wholesale | currency}}</td>
                                    <td class="text-right">{{entry.price | currency}}</td>
                                    <td class="text-right">{{entry.taxRate | percent:'1.2-2'}}</td>
                                    <td class="text-right">{{entry.tax | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.wholesale.collected | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="5">Sales tax due on wholesale transactions:</td>
                                <td></td>
                                <td class="text-right">{{grouped.wholesale.tax | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }

                @if (grouped && grouped.after && grouped.after.entries && (grouped.after.entries.length > 0)) {
                    <hr />

                    <h4>After-Sale Transactions</h4>

                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Stock</th>
                                <th>Customer</th>
                                <th class="text-right">Amount Paid</th>
                                <th class="text-right">Taxable Amount</th>
                                <th class="text-right">Tax Rate</th>
                                <th class="text-right">Tax Due</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of grouped.after.entries; track entry.id;) {
                                <tr>
                                    <td>{{entry.received | date:'shortDate'}}</td>
                                    <td>{{entry.stock}}</td>
                                    <td>{{entry.buyer}}</td>
                                    <td class="text-right">{{entry.afterSale | currency}}</td>
                                    <td class="text-right">{{0 | currency}}</td>
                                    <td class="text-right">{{entry.taxRate | percent:'1.2-2'}}</td>
                                    <td class="text-right">{{entry.tax | currency}}</td>
                                </tr>
                            }
                            <tr class="total">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{grouped.after.collected | currency}}</td>
                                <td class="text-right">{{grouped.after.taxable | currency}}</td>
                                <td class="text-right"></td>
                                <td class="text-right"></td>
                            </tr>
                            <tr class="total">
                                <td class="text-right" colspan="5">Sales tax due on after-sale transactions:</td>
                                <td></td>
                                <td class="text-right">{{grouped.after.tax | currency}}</td>
                            </tr>
                        </tbody>
                    </table>
                }
            }

        </main>
    }
</div>
